// Imported first by index.tsx: modules read texts while they load, so the translations
// have to be in place before any other import runs.
//
// Production loads the full export (every key, no label filter): shadow mode, so a key
// with a wrong label can only break dev, stag or demo, where it is fixed first. Every
// other environment loads translations.json, this app's keys plus the shared ones.
// REACT_APP_ENV is replaced at build time, so the bundler drops the branch it does not
// take and a bundle holds exactly one of the two files. yarn translations writes both.
import {
  ITranslationFile,
  setTranslations,
} from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";

const translations: ITranslationFile =
  process.env.REACT_APP_ENV === "PROD"
    ? // eslint-disable-next-line @typescript-eslint/no-var-requires
      require("@rentiohq/shared-frontend/dist/utils/i18n/locale/i18n.json")
    : // eslint-disable-next-line @typescript-eslint/no-var-requires
      require("./translations.json");

setTranslations(translations);
